import { Link } from '@inertiajs/react';

/**
 * Shows the sentences that preceded and followed the analyzed sentence in its
 * source chapter, plus a link back to the chapter. Renders nothing if neither
 * side has content.
 */
export default function ContextWindow({ analysisText, contextBefore, contextAfter, sourceChapter }) {
  const hasContext = (contextBefore && contextBefore.trim()) || (contextAfter && contextAfter.trim());
  if (!hasContext && !sourceChapter) return null;

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 p-5">
      {sourceChapter && (
        <div className="mb-3 flex items-baseline justify-between gap-4">
          <div className="text-xs uppercase tracking-wide text-gray-400 dark:text-gray-500">
            Context
          </div>
          <Link
            href={`/teacher/library/${sourceChapter.book_id}?chapter=${sourceChapter.id}`}
            className="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
          >
            {sourceChapter.book_title} · {sourceChapter.label || sourceChapter.title}
          </Link>
        </div>
      )}
      <p className="text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        {contextBefore && <span>{contextBefore} </span>}
        <span className="text-gray-900 dark:text-white font-medium">{analysisText}</span>
        {contextAfter && <span> {contextAfter}</span>}
      </p>
    </div>
  );
}
